window.onload = ()=> {
  const scrollDown = document.querySelector('.scroll-down') as HTMLElement
  const firstPage = document.querySelector('.first-page') as HTMLElement
  
  if (window.scrollY > 0)
    return

  scrollDown.classList.remove('invise')

  function hideScrollDownElementOnScroll() {
    if (!scrollDown.classList.contains('invise')) {
      scrollDown.classList.add('invise')
      window.removeEventListener('scroll', hideScrollDownElementOnScroll, false)
    }
  }

  window.addEventListener('scroll', hideScrollDownElementOnScroll, false)

  scrollDown.onclick = () => {
    window.scrollTo({
      top: firstPage.scrollHeight,
      behavior: "smooth"
    });

    scrollDown.classList.add('invise')
  }
}